import * as React from 'react';

import type { ResultsForecastRatio } from '../../../output/models';

import { fixed2, format, percent, textRed } from '../../../utils';

interface Props {
  resultsForecast: ResultsForecastRatio;
}

export const ResultsForecastRow: React.FC<Props> = ({ resultsForecast }) => {
  const quarter = resultsForecast.quarter_name.includes('-');

  return (
    <tr>
      <td className="border border-gray p-1.5 text-center md:px-1.25">
        {resultsForecast.accounting_period}
      </td>
      <td className="border border-gray p-1.5 text-center md:px-1.25">
        <a href={resultsForecast.pdf} target="_blank">
          {quarter ? (
            <>
              {resultsForecast.quarter_name}
              <br />
              予想
            </>
          ) : (
            <>
              <span className="hidden md:inline">{resultsForecast.quarter_name}予想</span>
              <span className="inline md:hidden">
                {resultsForecast.quarter_name}
                <br />
                予想
              </span>
            </>
          )}
        </a>
      </td>
      <td
        className={`border border-gray p-1.5 text-right md:px-1.25 ${textRed(
          resultsForecast.forecast_net_sales,
        )}`}
      >
        {format(resultsForecast.forecast_net_sales)}
      </td>
      <td
        className={`border border-gray p-1.5 text-right md:px-1.25 ${textRed(
          resultsForecast.forecast_operating_income,
        )}`}
      >
        {format(resultsForecast.forecast_operating_income)}
      </td>
      <td
        className={`border border-gray p-1.5 text-right md:px-1.25 ${textRed(
          resultsForecast.forecast_ordinary_income,
        )}`}
      >
        {format(resultsForecast.forecast_ordinary_income)}
      </td>
      <td
        className={`border border-gray p-1.5 text-right md:px-1.25 ${textRed(
          resultsForecast.forecast_net_income,
        )}`}
      >
        {format(resultsForecast.forecast_net_income)}
      </td>
      <td
        className={`border border-gray p-1.5 text-right md:px-1.25 ${textRed(
          resultsForecast.forecast_net_income_per_share,
        )}`}
      >
        {fixed2(resultsForecast.forecast_net_income_per_share)}
      </td>
      <td
        className={`border border-gray p-1.5 text-right md:px-1.25 ${textRed(
          resultsForecast.forecast_net_sales_operating_income_ratio,
        )}`}
      >
        {percent(resultsForecast.forecast_net_sales_operating_income_ratio)}
      </td>
      <td
        className={`border border-gray p-1.5 text-right md:px-1.25 ${textRed(
          resultsForecast.forecast_net_sales_ordinary_income_ratio,
        )}`}
      >
        {percent(resultsForecast.forecast_net_sales_ordinary_income_ratio)}
      </td>
      <td
        className={`border border-gray p-1.5 text-right md:px-1.25 ${textRed(
          resultsForecast.change_in_forecast_net_sales,
        )}`}
      >
        {percent(resultsForecast.change_in_forecast_net_sales)}
      </td>
      <td
        className={`border border-gray p-1.5 text-right md:px-1.25 ${textRed(
          resultsForecast.change_in_forecast_operating_income,
        )}`}
      >
        {percent(resultsForecast.change_in_forecast_operating_income)}
      </td>
      <td
        className={`border border-gray p-1.5 text-right md:px-1.25 ${textRed(
          resultsForecast.change_in_forecast_ordinary_income,
        )}`}
      >
        {percent(resultsForecast.change_in_forecast_ordinary_income)}
      </td>
      <td
        className={`border border-gray p-1.5 text-right md:px-1.25 ${textRed(
          resultsForecast.change_in_forecast_net_income,
        )}`}
      >
        {percent(resultsForecast.change_in_forecast_net_income)}
      </td>
    </tr>
  );
};
